// extracted by mini-css-extract-plugin
export var icon = "_aj-3";
export var subtitle = "_aj-2";
export var title = "_aj-1";
export var value = "_aj-0";